/* Stylesheet */

.simple_input {
  margin: 0px 2px 0px 2px;

  .input {
    --padding-start: 21px;
    background: var(--ion-gradient-light);
    box-shadow: var(--ion-box-shadow);
  }

  .error_container {
    margin: 12px 12px 0px 0px;
    display: flex;
    justify-content: flex-end;

    .message {
      font-size: 0.75rem;
      color: var(--ion-color-error);
      font-style: italic;
    }
  }
}
